import { useTranslation } from "react-i18next";

import { Container } from "../../../../components/Container";
import { useBillingLocationsExport } from "../../../../hooks/useBillingLocationsExport";
import { resetBillingLocationsList } from "../../../../middleware/listenerMiddleware/utils/resetBillingLocationsList";
import { useAppDispatch } from "../../../../store";
import { BillingLocationsTableType } from "../../../../types/billingLocations";
import { BillingCollectedFeeProgressBar } from "../../BillingCollectedFeeProgressBar";
import { BillingLocationsTable } from "../BillingLocationsTable";

import styles from "./BillingLocationsTableContainer.module.scss";

interface IBillingLocationsTableContainerProps {
  showRefreshButton?: boolean;
  showFeePercentageCollected?: boolean;
  tableType: BillingLocationsTableType;
}

export const BillingLocationsTableContainer: React.FC<IBillingLocationsTableContainerProps> = ({
  showRefreshButton,
  showFeePercentageCollected,
  tableType,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { handleExport } = useBillingLocationsExport();

  const handleRefresh = () => {
    resetBillingLocationsList(dispatch);
  };

  return (
    <Container>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h4 className={styles.title}>{t("billingLocationsTableContainer.locations")}</h4>
          </div>
          <div className={styles.headerRight}>
            {showFeePercentageCollected && <BillingCollectedFeeProgressBar />}
            {showRefreshButton && (
              <button className={styles.button} onClick={handleRefresh}>
                {t("billingLocationsTableContainer.refresh")}
              </button>
            )}
            <button className={styles.button} onClick={() => handleExport(tableType)}>
              {t("billingLocationsTableContainer.export")}
            </button>
          </div>
        </div>
        <BillingLocationsTable tableType={tableType} />
      </div>
    </Container>
  );
};
